/**
 * Every string SONMI says lives here so it can be reviewed as prose,
 * not scattered across components. Server-produced sentences (e.g.
 * the offer sentence) are preferred when available; these are the
 * fallbacks and the UI chrome.
 */
export const sonmiCopy = {
  // Pages
  page: {
    employees: {
      eyebrow: "Admin · Hidden route",
      title: "Employees",
      lede: "The employees SONMI knows about. Every status change is versioned so a mid-schedule promotion is provable years later.",
      empty: "No employees on file yet.",
      add: "Add an employee",
    },
    signon: {
      eyebrow: "Admin · Hidden route",
      title: "Sign-on Bonuses",
      lede: "SONMI's first proof. When a new MT is added, she'll notice, and offer to carry the 15-payment schedule.",
    },
  },

  // Common
  common: {
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    revoke: "Revoke permission",
    seeHistory: "See history",
    signedInAs: (email) => `Signed in as ${email}`,
  },

  // Offer card
  offer: {
    heading: "SONMI has an offer for you",
    yes: "Yes, manage this for me",
    notYet: "Not yet",
  },

  // Permission history
  permission: {
    grantedAt: (iso, actor) => `Granted on ${new Date(iso).toLocaleDateString()} by ${actor}.`,
    revokedAt: (iso, actor) => `Revoked on ${new Date(iso).toLocaleDateString()} by ${actor}.`,
    active: "Active",
    revoked: "Revoked",
    confidence: (n) => `Confidence: ${Math.round(n * 100)}%`,
    ledgerHeading: "Payments SONMI has committed",
    ledgerEmpty: "No payments yet — the first one lands on the first payroll of the month after eligibility begins.",
    confidenceEventsHeading: "Level changes SONMI recorded",
  },

  // Post-actions
  toast: {
    granted: "Thank you. SONMI has taken responsibility for this and will show her work each payroll.",
    revoked: "SONMI has stopped acting on this. Committed payments remain part of their payrolls.",
    statusChanged: "Status updated. SONMI will resolve the amount from the new status at each future payment.",
    employeeCreated: "Employee added. SONMI now has enough to offer to carry their sign-on bonus.",
  },
};
